import { render, staticRenderFns } from "./surface_container.vue?vue&type=template&id=0c7dd624&scoped=true&"
import script from "./surface_container.vue?vue&type=script&lang=ts&"
export * from "./surface_container.vue?vue&type=script&lang=ts&"
import style0 from "./surface_container.vue?vue&type=style&index=0&id=0c7dd624&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7dd624",
  null
  
)

export default component.exports